export default __webpack_public_path__ + "static/media/project-data-screen.0eda042f.png";